import { t as trans } from 'i18next';
enum VN_LANGUAGE {
  VI = 'vi',
}
const t = (
  key: string,
  defaultValue: string,
  params: any | null = {},
): string => {
  // i18n 尚未 init 時 trans() 會回 undefined（不會套用 defaultValue），
  // 退回 defaultValue 而不是空字串，避免模組載入時求值的常數整片變空白
  return (
    <string>(<unknown>trans(key, { ...params, defaultValue })) || defaultValue
  );
};

const getUserLanguagePreference = () => {
  const lang = localStorage.getItem('lang');
  return lang || 'zh'; // return 'zh' as the default language if no language preference is stored
};

export { t, getUserLanguagePreference, VN_LANGUAGE };
